export const PHOTO_EXTS = ".jpg,.png,.jpeg";
export const DOCUMENT_EXTS = ".pdf,.rtf,.doc,.docx";
export const MAX_FILE_SIZE_MB = 10;
export const APP_TITLE = "Triangular";
export const NO_RESTRICTIONS = "no_restrictions";
